import React from 'react'
import RefundLineItemWrapper from './lineItems/RefundLineItemWrapper'
import {RefundedNote} from 'app/features/orders/componentsv1/edit'
import {
  selectRefund,
  setRefundNote,
  selectOrderErrors,
  selectOrderProcessErrors,
} from 'app/features/orders/redux/order/refundSlice'
import {useDispatch, useSelector} from 'react-redux'
import {RootState} from 'setup'
import {RefundOrder as RefundOrderState} from 'app/features/orders/models/OrderRefundState'
import RefundSummaryAction from './summary/RefundSummaryAction'
import {Errors} from '../../../fulfillments/components'
import RefundAmount from './summary/RefundAmount'

export const RefundOrder: React.FC = () => {
  const dispatch = useDispatch()
  const refund = useSelector<RootState, RefundOrderState>(selectRefund)
  const errors = useSelector<RootState, any[]>(selectOrderErrors)
  const orderProcessErrors = useSelector<RootState, any[]>(selectOrderProcessErrors)

  const handleChangeNote = (note: string) => {
    dispatch(setRefundNote(note))
  }

  return (
    <div className='row gy-5 g-xl-8'>
      <div className='col-xl-8'>
        <RefundLineItemWrapper />
        <RefundedNote onNoteChange={handleChangeNote} note={refund.note} />
      </div>
      <div className='col-xl-4'>
        <RefundSummaryAction />
        <RefundAmount />
        <Errors errors={errors} />
        <Errors errors={orderProcessErrors} isShowOnlyError />
      </div>
    </div>
  )
}

export default RefundOrder
